/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Accountsetupcomplete2Inputs */

const en_accountsetupcomplete2 = /** @type {(inputs: Accountsetupcomplete2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Account setup complete`)
};

const de_accountsetupcomplete2 = /** @type {(inputs: Accountsetupcomplete2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konto-Einrichtung abgeschlossen`)
};

/**
* | output |
* | --- |
* | "Account setup complete" |
*
* @param {Accountsetupcomplete2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const accountsetupcomplete2 = /** @type {((inputs?: Accountsetupcomplete2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Accountsetupcomplete2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_accountsetupcomplete2(inputs)
	return de_accountsetupcomplete2(inputs)
});
export { accountsetupcomplete2 as "accountSetupComplete" }